import Vue from "vue";
import { bus } from "@/main";

export default {
	data() {
		return {
			loadImage: false,
			url: null,
			size: null,
		}
	},
	props:[
		"source",
		"caption",
		"wordpress",
		"forceSize"
	],
	created() {
		window.addEventListener("resize", () => {
			if(this.wordpress)
				this.evalSize();
		});
	},
	mounted() {
		if(this.wordpress)
			this.lazyLoad();
			this.evalSize();
	},
	watch: {},
	methods: {
		evalSize() {
			let elementWidth = this.$el.getBoundingClientRect().width;
		
			let size = this.size

			if ( elementWidth > 1440 )
				size = "huge"
			else if ( elementWidth > 1024  && this.size !== "huge" )
				size = "great"
			else if ( elementWidth > 768 && this.size !== "great" && this.size !== "huge" )
				size = "large"
			else if ( elementWidth > 200 && this.size  !== "large" && this.size !== "great" && this.size !== "huge" )
				size = "medium"
			
			else if ( this.size !== "medium" && this.size !== "large" && this.size !== "great" && this.size !== "huge" ){
				if ( this.source.sizes["small"])
					size = "small";
				else
					size = "thumbnail";
			}

			if ( !this.source.sizes[size])
				size = "original"

			if (this.forceSize)
				size = this.forceSize;

			this.size = size;
			this.url = this.source.sizes[size];
		},
		lazyLoad() {
			if ('IntersectionObserver' in window) {
				const image = this.$el;

				const options = {
					// If the image gets within 50px in the Y axis, start the download.
					root: null, // Page as root
					rootMargin: '0px',
					threshold: 0
				};
				
				const handleIntersection = (entries, observer) => {
					entries.forEach(entry => {
						if (entry.intersectionRatio > 0) {
							this.loadImage = true;
							this.evalSize();
						}
					})
				}

				const observer = new IntersectionObserver(handleIntersection, options);
				if(observer) 
					observer.observe(image);
			} else {
				this.loadImage = true
			}
		}
	}
}


// WEBPACK FOOTER //
// ./src/components/blocks/image/image.block.js